import { apiClient } from '../apiClient';
import { ApiActionResponse } from '../types';

export const updateUserLanguage = (languageCode: string) => {
  return apiClient.request<ApiActionResponse>('PUT', `/update-language`, { languageCode });
};
